export default __webpack_public_path__ + "static/media/mp_search_bar.83045968.svg";